export const REQUEST_UPGRADE_DESCRIPTION =
  'For you to engage more people every month, your role needs to be upgraded by an admin.';
export const REQUEST_UPGRADE_TITLE = 'Your role needs to be upgraded';
